import { createContext } from "react";

import { InvoiceViewHelper } from "./InvoiceViewHelper.ts";

export const InvoiceViewContext = createContext<InvoiceViewHelper>(
  {} as InvoiceViewHelper
);
